import { useAuthStore } from '@diamond/sol-admin/features/auth';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';

import { exclusionApi, ExclusionQuery } from '../api';

export function useExclusions(query: ExclusionQuery) {
  const { access_token, userId } = useAuthStore();
  const api = useMemo(() => exclusionApi(access_token), [access_token]);
  const client = useQueryClient();
  const scope = ['exclude-branch', userId];
  const list = useQuery({
    queryKey: [...scope, 'list', query],
    queryFn: () => api.list(query),
    retry: false,
  });
  const create = useMutation({ mutationFn: api.create, retry: false });
  const bulkCreate = useMutation({ mutationFn: api.bulkCreate, retry: false });
  const remove = useMutation({ mutationFn: api.remove, retry: false });
  const bulkRemove = useMutation({ mutationFn: api.bulkRemove, retry: false });
  const refresh = () => client.invalidateQueries({ queryKey: scope });
  return {
    api,
    list,
    create,
    bulkCreate,
    remove,
    bulkRemove,
    refresh,
    scope,
  };
}
